import { render, staticRenderFns } from "./BattlesGameElement.vue?vue&type=template&id=77b04f80&scoped=true"
import script from "./BattlesGameElement.vue?vue&type=script&lang=js"
export * from "./BattlesGameElement.vue?vue&type=script&lang=js"
import style0 from "./BattlesGameElement.vue?vue&type=style&index=0&id=77b04f80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b04f80",
  null
  
)

export default component.exports